export default __webpack_public_path__ + "locales/it/DownloadDialog.json?hash=f0aeddc9457f8143ff69358f6504cf65";